import React, { useState } from 'react';
import { Button, Modal, Space } from 'antd';
import JSONPretty from 'react-json-pretty';

interface IntegrationEventPayloadModalProps {
  payload: string;
}

export const IntegrationEventPayloadModal = ({ payload }: IntegrationEventPayloadModalProps) => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <span className="open-citations-btn" onClick={() => setIsOpen(true)}>
        View payload
      </span>
      <Modal centered title="Payload" width={700} open={isOpen} wrapClassName="custom-modal" closable={false}>
        <Space>
          <JSONPretty data={payload} />
        </Space>
        <Space className="footer">
          <Button type="link" onClick={() => setIsOpen(false)}>
            Close
          </Button>
        </Space>
      </Modal>
    </>
  );
};
